<script lang="ts" setup>
const { $t } = useLocalization();

interface Props
{
    form: any;
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    disabled: false
});

const emit = defineEmits<{
    (e: 'update:form', value: any): void;
}>();

// Reaktywny dostęp do form
const form = computed({
    get: () => props.form,
    set: value => emit('update:form', value)
});

const imageStyles: Option[] = [
    { value: 'studio-ghibli', text: $t('[[[Studio Ghibli]]]') },
    { value: 'pixar', text: $t('[[[Pixar]]]') },
    { value: 'cyberpunk', text: $t('[[[Cyberpunk]]]') },
    { value: 'synthwave', text: $t('[[[Synthwave]]]') },
    { value: 'pixel-art', text: $t('[[[Pixel art]]]') },
    { value: 'low-poly', text: $t('[[[Low‑poly]]]') },
    { value: 'steampunk', text: $t('[[[Steampunk]]]') },
    { value: 'dark-fantasy', text: $t('[[[Mroczne fantasy]]]') }
];

const mediums: Option[] = [
    { value: 'oil-painting', text: $t('[[[Olej na płótnie]]]') },
    { value: 'watercolor', text: $t('[[[Akwarela]]]') },
    { value: 'digital-painting', text: $t('[[[Cyfrowe malarstwo]]]') },
    { value: '3d-render', text: $t('[[[Render 3D]]]') },
    { value: 'photograph', text: $t('[[[Fotografia]]]') },
    { value: 'ink-drawing', text: $t('[[[Rysunek tuszem]]]') },
    { value: 'charcoal-sketch', text: $t('[[[Szkic węglem]]]') },
    { value: 'pixel-art', text: $t('[[[Pixel art]]]') },
    { value: 'claymation', text: $t('[[[Claymation]]]') }
];
</script>

<template>
    <IdeoFormGroup
        :invalid-feedback="form.$errors.first('imageStyle')"
        :state="form.$errors.state('imageStyle')"
        :label="$t('[[[Styl]]]')"
    >
        <IdeoFormSelect
            v-model="form.imageStyle"
            :options="imageStyles"
            :disabled="form.$loading || disabled"
        >
            <template #first>
                <option value="">
                    {{ $t('[[[wybierz]]]') }}
                </option>
            </template>
        </IdeoFormSelect>
        <template #description>
            <template v-for="(style, index) in imageStyles.slice(0, 3)" :key="style.value">
                <a>{{ style.text }}</a><span v-if="index < imageStyles.slice(0, 3).length - 1">, </span>
            </template>
        </template>
    </IdeoFormGroup>

    <IdeoFormGroup
        :label="$t('[[[Medium]]]')"
        :invalid-feedback="form.$errors.first('medium')"
        :state="form.$errors.state('medium')"
        nospace
    >
        <IdeoFormSelect
            v-model="form.medium"
            :options="mediums"
            :disabled="form.$loading || disabled"
        >
            <template #first>
                <option value="">
                    {{ $t('[[[wybierz]]]') }}
                </option>
            </template>
        </IdeoFormSelect>
        <template #description>
            <template v-for="(style, index) in mediums.slice(0, 3)" :key="style.value">
                <a>{{ style.text }}</a><span v-if="index < mediums.slice(0, 3).length - 1">, </span>
            </template>
        </template>
    </IdeoFormGroup>
</template>

<style lang="scss" scoped>
.h-33-5 {
    height: 30.85px;
}
</style>
